<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <path d="M7.5 15L12.5 10L7.5 5" stroke="#202830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
    name: 'IconRight',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
